import React, { ChangeEvent, FC, ReactNode } from 'react';

interface TextArea {
  name: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  maxNumberOfWords?: number;
  initialValue?: string;
  placeholder?: string;
  customLabel?: ReactNode;
  disabled?: boolean;
}

interface TextAreaLabel {
  label: string;
  name: string;
}

export const TextAreaLabel: FC<TextAreaLabel> = ({ label, name }) => {
  return (
    <label htmlFor={name} className='text-gray-60 text-lg flex items-center mb-2'>
      {label}
    </label>
  );
};

export const TextArea: FC<TextArea> = ({
  label,
  name,
  maxNumberOfWords = 160,
  value,
  onChange,
  placeholder,
  customLabel,
  disabled = false
}) => {
  const textareaChangeHandler = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length <= maxNumberOfWords) onChange(e.target.value);
  };
  return (
    <div className='flex flex-col font-effra' data-testid={`text-area-${name}`}>
      {customLabel || (label && <TextAreaLabel label={label} name={name} />)}
      <div className='flex flex-col border-1 rounded-lg border-gray-65 overflow-hidden pt-2 pl-2 pr-2 pb-1'>
        <textarea
          id={name}
          value={value}
          onChange={textareaChangeHandler}
          placeholder={placeholder}
          disabled={disabled}
          className='focus:outline-none active:outline-none resize-none h-16 text-black-default text-lg'
          data-testid={`textArea_${name}`}
        />
        <p className='text-right text-base text-gray-60' data-testid={`textarea-characterLimit-${name}`}>
          {!value.length ? '#' : value.length}/{maxNumberOfWords}
        </p>
      </div>
    </div>
  );
};
